import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '730px',
    minWidth: '299px',
    width: '100%',
    alignSelf: 'center',
    marginBottom: '90px',
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
    },
    fontSize: '33px',
    fontWeight: '400',
    color: '#fff',
    marginBottom: '24px',
  },
  selectContainer: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    maxWidth: '450px',
  },
  select: {
    width: 'fit-content',
    backgroundColor: '#292929',
    borderRadius: '8px!important',
    fontSize: '14px!important',
    '& .MuiSelect-select': {
      alignItems: 'center!important',
      minHeight: '0!important',
      display: 'flex!important',
      height: '20px!important',
      border: '1px solid #404040!important',
      borderRadius: '8px!important',
      padding: '7px 32px 7px 12px!important',
      color: '#fff!important',
    },
    '&.MuiOutlinedInput-root': {
      minHeight: '0px!important',
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        borderColor: '#404040',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none!important',
    },
  },
  selectPaper: {
    marginTop: '6px!important',
    border: '1px solid #404040!important',
    '& .MuiList-root': {
      padding: '0px!important',
      '& .MuiMenuItem-root': {
        fontSize: '13px',
        padding: '0 12px!important',
        borderRadius: '0!important',
        color: '#fff!important',
        '&:hover': {
          backgroundColor: '#232323!important',
        },
      },
    },
  },
  searchbar: {
    '&::placeholder': {
      color: '#888888',
      fontSize: '14px',
      fontWeight: '400',
      border: 'none!important',
    },
    width: '470px',
    minWidth: '0px',
    maxWidth: '-webkit-fill-available',
    height: '36px',
    borderRadius: '8px',
    padding: '8px 12px',
    color: '#fff',
    backgroundColor: '#292929',
    border: '1px solid #404040',
    fontSize: '14px',
    fontWeight: '400',
    outline: 'none',
  },
  pagination: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: '#ffffff',
    margin: '1rem 0',
  },
  infiniteScroll: {
    marginTop: '18px',
  },
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    minHeight: '58px',
    border: '1px solid #404040',
    backgroundColor: '#161616',
    padding: '12px',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '400',
    marginBottom: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  clickableCard: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardLabel: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '420px',
    gap: '8px',
  },
  cardActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'flex-end',
    },
  },
  cardTimestampContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
  },
  cardTimestamp: {
    color: '#888888',
    display: 'flex',
    fontSize: '12px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    textWrap: 'balance',
    minWidth: '64px',
    textAlign: 'right',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
    },
  },
  cardStatus: {
    fontSize: '13px',
    textWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  cardButtonGrid: {
    display: 'flex',
    gap: '8px',
  },
  cardButton: {
    display: 'flex',
    height: 'fit-content',
    cursor: 'pointer',
  },
  communityCard: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    border: '1px solid #404040',
    backgroundColor: '#161616',
    padding: '12px 8px 12px 12px',
    borderRadius: '8px',
    color: '#fff',
    marginBottom: '12px',
    [theme.breakpoints.down('xs')]: {
      padding: '8px 6px 8px 8px',
    },
  },
  communityCardColumn: {
    display: 'flex',
    gap: '12px',
  },
  communityCardActions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  coverImg: {
    userSelect: 'none',
    borderRadius: '4px',
    border: '1px solid #404040',
    width: '86px',
    [theme.breakpoints.down('xs')]: {
      width: '72px',
    },
  },
  communityCardLabel: {
    fontSize: '20px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
  },
  communityCardInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  communityCardSubInfo: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '12px',
    color: '#9A9A9A',
    gap: '4px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
    },
  },
  cardButtonGrid: {
    display: 'flex',
    gap: '6px',
  },
  communityCardButton: {
    display: 'flex',
    cursor: 'pointer',
  },
  communityCardLikes: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginRight: '4px',
  },
  playButtonImg: {
    userSelect: 'none',
    fontSize: '50px',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  playButtonGrid: {
    direction: 'row-reverse',
    justifyContent: 'flex-end',
  },
  favoriteImg: {
    userSelect: 'none',
    flexShrink: '0',
    fontSize: '2rem',
    cursor: 'pointer',
  },
  favoriteFullImg: {
    userSelect: 'none',
    flexShrink: '0',
    fontSize: '2rem',
    cursor: 'pointer',
    color: '#d32f2f',
  },
  numberLikes: {
    fontSize: '0.8rem',
    marginLeft: '.1rem',
    marginRight: '.1rem',
  },
  communityCardStatus: {
    textAlign: 'center',
    marginLeft: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '0.8rem',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      marginLeft: '0rem',
    },
  },
  ttiCardGrid: {
    borderRadius: '8px !important',
    gap: '16px',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#9A9A9A',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#9A9A9A',
    },
  },
  dragAndDropText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
    fontWeight: '300',
    fontSize: '14px',
    color: '#9A9A9A',
    textAlign: 'center',
  },
  selectModelButton: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
      gap: '0.5rem',
      fontSize: '10px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: `10rem`,
    height: '10rem',
    borderWidth: 2,
    backgroundColor: '#292929',
    border: '1px dashed #404040',
    borderRadius: '8px',
    //transition: "border .24s ease-in-out",
    fontSize: '14px',
    cursor: 'pointer',
  },
  addButtonImg: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
    },
    fontSize: '54px !important',
    color: '#9A9A9A',
  },
  ttiCard: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
      fontSize: '1rem',
    },
    flex: '0 0 auto',
    width: `10rem`,
    height: '10rem',
    backgroundColor: '#161616',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '1.5rem',
    fontWeight: '400',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  ttiCardCoverImg: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
    },
    position: 'absolute',
    zIndex: '0',
    borderRadius: '0.5rem',
    width: `10rem`,
    height: '10rem',
    objectFit: 'cover',
  },
  usageTag: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.65rem',
    },
    position: 'absolute',
    zIndex: '3',
    borderRadius: '1rem',
    padding: '3px 5px',
    fontSize: '11px',
    fontWeight: '400',
    color: '#000',
    backgroundColor: '#fff',
    top: '8px',
    left: '8px',
    border: '1px solid #e2e2e2',
  },
  ttiCardContent: {
    position: 'absolute',
    width: '100%',
    zIndex: '2',
    display: 'flex',
    flexDirection: 'column',
    alightItems: 'center',
    gap: '3px',
    borderRadius: '0 0 0.5rem 0.5rem',
    bottom: '0',
    backgroundColor: 'rgb(0, 0, 0, 0.6)',
    padding: '5px',
  },
  ttiCardContentFirstRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  ttiCardLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      lineHeight: '0.8rem',
    },
    display: '-webkit-box',
    width: 'auto',
    fontSize: '0.85rem',
    lineHeight: '0.9rem',
    overflowWrap: 'anywhere',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  ttiCardTimestamp: {
    //marginTop: "3.3rem",
    // alightItems: 'flex-end',
    display: 'flex',
    // marginLeft: '0.3rem',
    justifyContent: 'space-between',
    fontSize: '0.65rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    //whiteSpace: "nowrap",
    [theme.breakpoints.down(476)]: {
      fontSize: '0.6rem',
    },
  },
  modelDeleteButton: {
    position: 'absolute',
    top: '8px',
    right: '0.4rem',
    cursor: 'pointer',
  },
  modelDeleteIcon: {
    color: '#fff',
    width: '18px',
    filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.6))',
  },
  modelEditButton: {
    [theme.breakpoints.down('xs')]: {
      top: '4.6rem',
    },
    position: 'absolute',
    zIndex: '3',
    top: '5.2rem',
    right: '0.5rem',
    cursor: 'pointer',
  },
  imgEditIcon: {
    color: '#fff',
    width: '1.2rem !important',
    cursor: 'pointer',
    filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.6))',
  },
  ttiCardStatus: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.8rem',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      fontSize: '10px',
    },
  },
  ttiCardEditIcon: {
    [theme.breakpoints.down('xs')]: {
      width: '0.9rem!important',
    },
    width: '1rem!important',
    height: 'auto!important',
    marginLeft: '2px',
    marginBottom: '1px',
    cursor: 'pointer',
  },
}));

export { useStyles };
